// extracted by mini-css-extract-plugin
export default {"loading":"loading5_loading__osLQb","loading-ani":"loading5_loading-ani__rRghu"};